import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";
import { useSettings } from "@/context/SettingsContext";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { label: "Início", href: "/#inicio" },
  { label: "Metodologia", href: "/#metodologia" },
  { label: "Cursos", href: "/#cursos" },
  { label: "Como funciona", href: "/#como-funciona" },
  { label: "Assinatura", href: "/#assinatura" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { openWhatsapp } = useSettings();
  const { user } = useAuth();
  const nav = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 glass" data-testid="public-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-logo"><Logo size={50} /></Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <a key={n.label} href={n.href} className="text-sm text-chessup-subtext hover:text-chessup-turq transition-colors" data-testid={`nav-${n.label}`}>
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button onClick={() => openWhatsapp("homepage")} className="text-sm px-4 py-2 rounded-full border border-chessup-border text-chessup-text hover:border-chessup-turq transition-colors" data-testid="nav-whatsapp-btn">
            FALAR NO WHATSAPP
          </button>
          {user ? (
            <button onClick={() => nav("/painel")} className="text-sm px-4 py-2 rounded-full bg-chessup-gold text-chessup-deep font-semibold hover:bg-chessup-goldlight transition-colors" data-testid="nav-dashboard-btn">
              MEU PAINEL
            </button>
          ) : (
            <>
              <Link to="/entrar" className="text-sm text-chessup-text hover:text-chessup-turq" data-testid="nav-login-btn">Entrar</Link>
              <Link to="/criar-conta" className="text-sm px-4 py-2 rounded-full bg-chessup-gold text-chessup-deep font-semibold hover:bg-chessup-goldlight transition-colors" data-testid="nav-signup-btn">
                COMEÇAR AGORA
              </Link>
            </>
          )}
        </div>

        <button className="lg:hidden text-chessup-text" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden glass border-t border-chessup-border px-4 py-4 space-y-3 animate-fade-in" data-testid="nav-mobile-menu">
          {NAV.map((n) => (
            <a key={n.label} href={n.href} onClick={() => setOpen(false)} className="block text-chessup-subtext hover:text-chessup-turq py-1">{n.label}</a>
          ))}
          <div className="pt-2 flex flex-col gap-2">
            <button onClick={() => { openWhatsapp("homepage"); setOpen(false); }} className="w-full py-2.5 rounded-full border border-chessup-border text-chessup-text">FALAR NO WHATSAPP</button>
            {user ? (
              <button onClick={() => nav("/painel")} className="w-full py-2.5 rounded-full bg-chessup-gold text-chessup-deep font-semibold">MEU PAINEL</button>
            ) : (
              <>
                <Link to="/entrar" className="w-full py-2.5 rounded-full border border-chessup-border text-chessup-text text-center">Entrar</Link>
                <Link to="/criar-conta" className="w-full py-2.5 rounded-full bg-chessup-gold text-chessup-deep font-semibold text-center">COMEÇAR AGORA</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
